import type { TypographyVariantsOptions } from '@mui/material/styles'
import { colorTokens } from './colorTokens'

/**
 * Typography Tokens (Font Families & Font Sizes)
 * Aligned with defaultTheme.ts and standard MUI type scale.
 */
export const typographyTokens = {
    fontFamily: {
        head: "var(--font-head, 'DB Head Black')",
        sans: "var(--font-sans, 'DB Sans Regular')",
    },
    fontSize: {
        xs: '0.75rem', // caption / overline / subtitle2 (12px)
        sm: '0.875rem', // body2 (14px)
        md: '1rem', // body1 / subtitle1 (16px)
        lg: '1.125rem', // 18px
        xl: '1.25rem', // h6 (20px)
    },
    fontWeight: {
        regular: 400,
        bold: 600,
    },
} as const

/**
 * Typography theme configuration matching the design scale
 * Headings use DB Head Black; Body & UI elements stay close to standard MUI sizes.
 */
export const typographyTheme: TypographyVariantsOptions = {
    fontFamily: typographyTokens.fontFamily.sans,
    h1: { fontFamily: typographyTokens.fontFamily.head },
    h2: { fontFamily: typographyTokens.fontFamily.head },
    h3: { fontFamily: typographyTokens.fontFamily.head },
    h4: { fontFamily: typographyTokens.fontFamily.head },
    h5: { fontFamily: typographyTokens.fontFamily.head, fontSize: typographyTokens.fontSize.lg },
    h6: {
        fontFamily: typographyTokens.fontFamily.sans,
        fontSize: typographyTokens.fontSize.lg,
    },
    subtitle1: { fontSize: typographyTokens.fontSize.md },
    subtitle2: { fontSize: typographyTokens.fontSize.xs, color: colorTokens.text.secondary },
    body1: { fontSize: typographyTokens.fontSize.md },
    body2: { fontSize: typographyTokens.fontSize.sm },
    caption: { fontSize: typographyTokens.fontSize.xs },
    overline: {
        fontSize: typographyTokens.fontSize.xs,
        lineHeight: 1.0,
        display: 'block',
        color: colorTokens.text.disabled,
    },
    button: {
        textTransform: 'none',
    },
}
